import { Suspense, lazy, useMemo } from "react";
import { jsx } from "react/jsx-runtime";
import { SuspenseFallback } from "@tecnobit-srl/components-store";
//#region src/use-you-tube-video.tsx
var LazyYouTubeVideo = lazy(() => import("./you-tube-video-C-3XRESt.js").then((n) => n.n).then((module) => ({ default: module.YouTubeVideo })));
var LazyYouTubeThumbnail = lazy(() => import("./you-tube-thumbnail-C1VPKE1D.js").then((n) => n.n).then((module) => ({ default: module.YouTubeThumbnail })));
function YouTubeVideo({ ...props }) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "you-tube-video" }),
		children: /* @__PURE__ */ jsx(LazyYouTubeVideo, { ...props })
	});
}
function YouTubeVideoContent({ ...props }) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "you-tube-video" }),
		children: /* @__PURE__ */ jsx(LazyYouTubeVideo, { ...props })
	});
}
function YouTubeThumbnail({ ...props }) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "you-tube-video" }),
		children: /* @__PURE__ */ jsx(LazyYouTubeThumbnail, { ...props })
	});
}
var useYouTubeVideoContent = () => {
	return useMemo(() => ({ youtubeVideo: { component: YouTubeVideoContent } }), []);
};
//#endregion
export { YouTubeThumbnail, YouTubeVideo, useYouTubeVideoContent };
